import svg from 'src/images/custom-icons/documents.icon.svg';

const documentsSideBarTokens = {
    iconData: svg,
    iconWidth: 16,
    iconHeight: 20,
    iconTitle: 'Documents'
};

export default documentsSideBarTokens;
